"use strict";
/*
 * Created on 3. 12. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var PriceFormulas_1 = require("../../core/model/math/PriceFormulas");

var utils_1 = require("../../core/utils");
/**
 * Sums of values for impact record before final aggregation.
 * @author Radek Beran
 */


var ImpactRecordSums =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ImpactRecordSums, _DomainObject_1$Domai);

  function ImpactRecordSums(id, releaseId, categoryId, priceZoneId, marginConstraint, optimizationGoal, exportedCount, storesCount, marginOldUpperSum, marginOldWeightSum, marginNewUpperSum, marginNewWeightSum, revenueOldUpperSum, revenueOldWeightSum, revenueNewUpperSum, revenueNewWeightSum, profitOldUpperSum, profitOldWeightSum, profitNewUpperSum, profitNewWeightSum) {
    var _this;

    _classCallCheck(this, ImpactRecordSums);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImpactRecordSums).call(this));
    _this.id = id;
    _this.releaseId = releaseId;
    _this.categoryId = categoryId;
    _this.priceZoneId = priceZoneId;
    _this.marginConstraint = marginConstraint;
    _this.optimizationGoal = optimizationGoal;
    _this.exportedCount = exportedCount;
    _this.storesCount = storesCount;
    _this.marginOldUpperSum = marginOldUpperSum;
    _this.marginOldWeightSum = marginOldWeightSum;
    _this.marginNewUpperSum = marginNewUpperSum;
    _this.marginNewWeightSum = marginNewWeightSum;
    _this.revenueOldUpperSum = revenueOldUpperSum;
    _this.revenueOldWeightSum = revenueOldWeightSum;
    _this.revenueNewUpperSum = revenueNewUpperSum;
    _this.revenueNewWeightSum = revenueNewWeightSum;
    _this.profitOldUpperSum = profitOldUpperSum;
    _this.profitOldWeightSum = profitOldWeightSum;
    _this.profitNewUpperSum = profitNewUpperSum;
    _this.profitNewWeightSum = profitNewWeightSum;
    return _this;
  }

  _createClass(ImpactRecordSums, null, [{
    key: "initial",
    value: function initial(releaseId, categoryId, priceZoneId) {
      return new ImpactRecordSums(utils_1.Utils.VOID_ID, releaseId, categoryId, priceZoneId, null, null, 0, 0, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO, PriceFormulas_1.PriceFormulas.ZERO);
    }
  }]);

  return ImpactRecordSums;
}(DomainObject_1.DomainObject);

exports.ImpactRecordSums = ImpactRecordSums;